import { useEffect, useState } from 'react';
import { getServerUrl } from '../../universal-nav/utils/getServerUrl';
import { isEmptyObject } from '../../universal-nav/utils/isEmptyObject';

// Possible treatments for the payment retry AlertBanner feature
export type SplitTreatment = 'on' | 'off';

type usePaymentRetryTreatmentReturn = {
  isLoading: boolean;
  treatment: SplitTreatment;
};

// Coda brief: https://coda.io/d/Billing_dPgPHC1Ds0u/Pay-Now-On-Demand-Payment-Retry-When-Dunning_suwmX
export const usePaymentRetryTreatment = (
  accountId?: string | number
): usePaymentRetryTreatmentReturn => {
  const [isLoading, setIsLoading] = useState(true);
  const [treatment, setTreatment] = useState<SplitTreatment>('off');

  useEffect(() => {
    let apiSubscribed = true;

    const serverUrl = getServerUrl();
    const paymentRetryTreatmentUrl = `${serverUrl}/billing-data/payment-retry-treatment`;

    async function getSplitData() {
      try {
        setIsLoading(true);

        const response = await fetch(paymentRetryTreatmentUrl, {
          headers: { 'x-account-id': accountId?.toString() ?? '0' },
        });

        if (!response.ok) {
          throw new Error('Response was not OK');
        }

        if (apiSubscribed) {
          const json = await response.json();
          const { data } = json;
          if (!isEmptyObject(data)) setTreatment(data);
        }
      } catch (error) {
        // Default to off if there's an error
        setTreatment('off');
      } finally {
        if (apiSubscribed) {
          setIsLoading(false);
        }
      }
    }

    getSplitData();

    return () => {
      apiSubscribed = false;
    };
  }, [accountId]);

  return { isLoading, treatment };
};
